import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { categoryTimeTypeTag } from 'modules/attendance/components/CustomTimeRanges/Content/utils/categoryNameWithTimeTypeLabel'
import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

interface Props {
  category: CustomTimeRangeCategory
}

const CategoryTag = ({ category }: Props) => {
  return (
    <Box>
      <Tag type={categoryTimeTypeTag(category.timeType)}>{category.tagLabel}</Tag>
    </Box>
  )
}

export default CategoryTag
